import styled from "@emotion/styled";
import { Chip } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const OrderCard = styled.div(({ theme, onClick }) => ({
	...(onClick && {
		cursor: "pointer",
		"&:hover": {
			backgroundColor: theme.project.colors.backgroundColors["card:hover"]
		}
	}),
	display: "flex",
	flexDirection: "row",
	gap: "4px",
	padding: "16px",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray50,
	border: "1px solid",
	borderColor: theme.palette.divider
}));

export const OrderDetails = styled.div({
	gap: "4px",
	display: "flex",
	justifyContent: "space-between",
	flexDirection: "column"
});

export const FieldDetails = styled.div({
	gap: "12px",
	display: "flex",
	justifyItems: "space-between",
	alignItems: "center",
	flexDirection: "row"
});

export const JobName = styled.h6(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.palette.text.primary,
	margin: 0
}));

export const TruckOrderType = styled(Chip)(({ theme }) => ({
	...theme.project.typography.chipLabel,
	display: "flex",
	height: "1.5rem",
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.disabled,
	textTransform: "capitalize",
	borderRadius: "100px",
	cursor: "pointer",
	color: theme.palette.text.primary,
	width: "fit-content",
	"& .MuiChip-label": {
		paddingTop: 2.5
	}
}));

export const FieldName = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.palette.text.primary
}));

export const FieldValue = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.palette.text.secondary
}));

export const ArrowContainer = styled.div({
	display: "flex",
	alignItems: "center",
	justifyContent: "flex-end",
	flex: 1
});

export const ArrowIcon = styled(ChevronRightIcon)({
	cursor: "pointer",
	height: "24px",
	width: "24px"
});

export const TruckFlyoutOrderCardChips = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "4px",
	div: {
		width: "fit-content"
	}
});
